import { Injector, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import _isString from 'lodash/isString';
import { SimpleVideo } from '@portal/models/simpleVideo';
import { getImagesEndpoint } from '@portal/api-endpoints';
import { SafePipe, SafePipeTypes } from '@portal/core';
import { AGENT_TYPE } from '../../auth.constants';

@Pipe({
  name: 'video',
  pure: true,
  standalone: true,
})
export class VideoPipe implements PipeTransform {
  private readonly contentApi = getImagesEndpoint(this.injector.get(AGENT_TYPE));

  constructor(
    private readonly domSanitizer: DomSanitizer,
    private readonly injector: Injector,
  ) {}

  transform(value?: SimpleVideo | string | null): SafeUrl {
    if (!value) {
      return null;
    }
    const path = _isString(value) ? value : value.path;
    if (!path) {
      return null;
    }
    return new SafePipe(this.domSanitizer).transform(`${this.contentApi}${path}`, SafePipeTypes.Url);
  }
}
